import {useState} from 'react';
import { Provider } from 'react-redux';

import LumeraPersistGate from '@components/LumeraPersistGate';

import DyorServerDataSynchronizer from '@src/components/synchronizers/DyorServerDataSynchronizer';
import DyorDiamondDataSynchronizer from '@src/components/synchronizers/DyorDiamondDataSynchronizer';
import DyorSettingDataSynchronizer from '@src/components/synchronizers/DyorSettingDataSynchronizer';

const DyorSynchronizers = React.memo(function DyorSynchronizers () {
  const [synchronized, setSynchronized] = useState(false);

  return (
    <LumeraPersistGate>
      <Provider store={ReactOnRails.getStore('SharedReduxStore')}>
        <DyorServerDataSynchronizer setSynchronized={setSynchronized} />
        <DyorDiamondDataSynchronizer synchronized={synchronized} />
        <DyorSettingDataSynchronizer synchronized={synchronized} />
      </Provider>
    </LumeraPersistGate>
  );
});

export default () => <DyorSynchronizers />;
